import { permissionIds, type PermissionId } from '@dispatch/domain';

export { permissionIds };
export type { PermissionId };

export const permissionLabels: Readonly<Record<PermissionId, string>> = {
  'business.manage_settings': 'Manage business settings',
  'business.manage_branding': 'Manage branding',
  'business.manage_email': 'Manage email settings',
  'users.manage': 'Manage users',
  'permissions.delegate': 'Delegate permissions',
  'devices.manage': 'Manage registered devices',
  'templates.build': 'Build templates',
  'templates.publish': 'Publish templates',
  'templates.retire': 'Retire and archive templates',
  'templates.folders_manage': 'Manage template folders',
  'templates.examples_submit': 'Submit example templates',
  'reference.manage': 'Manage reference data',
  'jobs.create': 'Create dispatches',
  'jobs.self_dispatch': 'Self-dispatch',
  'jobs.assign': 'Assign and reassign jobs',
  'jobs.dispatch': 'Dispatch jobs',
  'jobs.recall_cancel': 'Recall and cancel jobs',
  'jobs.view_active': 'View all active jobs',
  'reports.review': 'Review completed reports',
  'reports.download': 'Download reports and assets',
  'reports.resend': 'Resend reports',
  'reports.void': 'Void reports',
  'reports.archive': 'Archive reports',
  'exports.create': 'Create exports',
  'audit.view': 'View audit logs',
  'legal_hold.manage': 'Manage legal holds',
};
